<template>
  <div>
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FF6907" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color:#fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color:#fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <div class="full-screen-map-wrapper">
      <BaseLeafletMap
        title="Rescuers Map"
        :layers="mappedLayers"
        :statistics="mapStats"
        :loading="appLoading"
        :toolbar="{ search: true, fullscreen: true, fitBounds: true, satellite: true }"
        height="100vh"
        @marker-click="onMarkerClick"
            >
            </BaseLeafletMap>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import BaseLeafletMap   from '@/components/maps/BaseLeafletMap.vue';
import RescuerPopup     from '@/components/maps/popups/RescuerPopup.vue';
import { layerFactory } from '@/components/maps/utils/layerFactory';
import { LAYER_TYPES }  from '@/components/maps/constants/layerTypes';
import { STATUS_COLORS, getRescuerColor } from '@/components/maps/constants/statusColors';
import { createMarkerIcon } from '@/components/maps/utils/markerFactory';
import { MARKER_TYPES }     from '@/components/maps/constants/markerTypes';

export default {
  components: { BaseLeafletMap },

  data() {
    return {
      appLoading:   false,
      ServerError:  false,
      showSnackBar: false,
      timeout:      5000,
      msg:          null,
      data:         [],
      totalcount:   0,
      keyword:      '',
      alldata:      true,
      districtdata: false,
    };
  },

  computed: {
    districts() {
      return ['All', ...this.$store.state.districts];
    },

    usersWithoutLocation() {
      if (!this.data || !this.data.length) return 0;
      return this.data.filter(u => !u.location || u.location.length !== 2).length;
    },

    rescuerStatusCounts() {
      const counts = { available: 0, busy: 0, offline: 0 };
      this.data.forEach(r => {
        let s = 'offline';
        if (typeof r.status === 'string') s = r.status.toLowerCase();
        else if (typeof r.availability === 'string') s = r.availability.toLowerCase();
        else if (r.is_rescuer_Available === true) s = 'available';
        else if (r.is_rescuer_Available === false) s = 'busy';
        
        if (s.includes('available')) counts.available++;
        else if (s.includes('busy')) counts.busy++;
        else counts.offline++;
      });
      return counts;
    },

    mappedLayers() {
      return [
        layerFactory({
          id:         LAYER_TYPES.RESCUERS,
          title:      'Rescuers',
          color:      STATUS_COLORS.AVAILABLE,
          clustered:  false,
          searchable: true,
          legend: [
            { color: STATUS_COLORS.AVAILABLE, label: 'Available' },
            { color: STATUS_COLORS.BUSY,      label: 'Busy'      },
            { color: STATUS_COLORS.OFFLINE,   label: 'Offline'   },
          ],
          markers: this.data
            .filter(u => u.location && u.location.length === 2)
            .map(u => {
              let status = 'offline';
              if (typeof u.status === 'string') status = u.status.toLowerCase();
              else if (typeof u.availability === 'string') status = u.availability.toLowerCase();
              else if (u.is_rescuer_Available === true) status = 'available';
              else if (u.is_rescuer_Available === false) status = 'busy';
              
              const color  = getRescuerColor(status);
              return {
                id:           u._id,
                lat:          u.location[1],
                lng:          u.location[0],
                layer:        LAYER_TYPES.RESCUERS,
                status,
                icon:         createMarkerIcon(MARKER_TYPES.RESCUER, color),
                popup:        RescuerPopup,
                searchFields: [u.name, u.phone, u.district, u.email].filter(Boolean),
                data:         u,
              };
            }),
        }),
      ];
    },

    mapStats() {
      const c = this.rescuerStatusCounts;
      return [
        { title: 'Total Rescuers', value: this.totalcount, icon: 'mdi-shield-account', color: STATUS_COLORS.AVAILABLE },
        { title: 'Available',      value: c.available,     icon: 'mdi-check-circle',   color: STATUS_COLORS.AVAILABLE },
        { title: 'Busy',           value: c.busy,          icon: 'mdi-clock-outline',  color: STATUS_COLORS.BUSY      },
        { title: 'Offline',        value: c.offline,       icon: 'mdi-circle-off-outline', color: STATUS_COLORS.OFFLINE },
      ];
    },
  },

  watch: {
    keyword() {
      this.getData();
    },
  },

  beforeMount() {
    this.getData();
    this.$store.dispatch('fetchDistricts');
  },

  methods: {
    checkUpdate(type) {
      if (type === 'all') {
        if (this.alldata) {
          this.districtdata = false;
          this.keyword      = '';
          this.getData();
        }
      } else if (type === 'district') {
        if (this.districtdata) this.alldata = false;
      }
      if (!this.districtdata && !this.alldata) {
        this.alldata = true;
        this.getData();
      }
    },

    getData() {
      this.appLoading = true;
      axios({
        method:  'GET',
        url:     '/users/rescuers/all',
        headers: { 'x-auth-token': localStorage.getItem('token') },
        params:  { keyword: this.keyword },
      })
        .then(response => {
          if (response.data.status === true) {
            this.data       = response.data.data;
            this.totalcount = this.data.length;
          } else {
            this.msg = response.data.msg; this.showSnackBar = true;
          }
        })
        .catch(err => { this.ServerError = true; console.log(err); })
        .finally(() => { this.appLoading = false; });
    },

    onMarkerClick({ data }) {
      console.log('Rescuer clicked:', data.name);
    },

    formatDate(date) {
      if (!date) return '-';
      const [year, month, day] = date.slice(0, 10).split('-');
      return `${day}-${month}-${year}`;
    },
  },
};
</script>
<style scoped>
.full-screen-map-wrapper {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.floating-warning {
  position: absolute;
  top: 80px;
  left: 16px;
  z-index: 1200;
  max-width: 320px;
  pointer-events: auto;
}

.warning-content {
  display: flex;
  align-items: flex-start;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(12px);
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 8px 32px rgba(0,0,0,0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.warning-content:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 36px rgba(0,0,0,0.12);
}

.warning-text {
  font-family: 'Poppins', poppinsregular, sans-serif;
  font-size: 12.5px;
  color: #4b5563;
  line-height: 1.5;
}

.warning-text strong {
  color: #1f2937;
  font-weight: 700;
}
</style>

<style scoped>
.heading     { font-family: poppinsregular; font-size: 20px; font-weight: 900; }
.subheading1 { font-family: poppinsregular; font-size: 15px; font-weight: 500; }
</style>